import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=6a168ed2&scoped=true"
import script from "./Draft.vue?vue&type=script&lang=js"
export * from "./Draft.vue?vue&type=script&lang=js"
import style0 from "./Draft.vue?vue&type=style&index=0&id=6a168ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a168ed2",
  null
  
)

export default component.exports